<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T9At2A/tc-custom/9781683351061.jpg?1699126856751" alt="This image is the cover for the book Skinful of Shadows"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skinful of Shadows
      </h1>
      <p class="bookDescription body article font2">
        <b>From the award–winning author of <i>The Lie Tree</i>, “a delicious combination of historical adventure, coming-of-age tale, and supernatural intrigue” (<i>Publishers Weekly</i>, starred review).</b><br/><br/>Sometimes, when a person dies, their spirit goes looking for somewhere to hide. Some people have space within them, perfect for hiding<br/><br/>Young Makepeace has learned to defend herself from the ghosts that try to possess her in the night, desperate for refuge, but one day a dreadful event causes her to drop her guard. And now there’s a spirit inside her.<br/><br/>The spirit is wild, brutish, and strong, and it may be her only defense when she is sent to live with her father’s rich and powerful family. There is talk of civil war, and they need people like her to protect their dark and terrible family secret. But as she plans to escape and heads out into a country torn apart by war, Makepeace must decide which is worse: possession—or death.<br/><br/><b>“Darkly splendid . . . a wonderful, resonant narrative whose subtlety and insight will challenge, entertain and enchant.” —<i>The Guardian</i></b><br/><br/><b>“<i>A Skinful of Shadows</i> is outlandishly creative and thoroughly blood-chilling. Her storytelling is visceral and unfurls at an exciting pace, making this novel a wonderful, weird and terrifying addition to her body of work.” —<i>Shelf Awareness </i>(starred review)</b><br/><br/><b></b><br/><br/><b>“A book that only Hardinge could write . . . [a] masterful and spooky historical fantasy.” —<i>School Library Journal</i> (starred review)</b><br/><br/><b>“Hardinge’s writing is stunning, and readers will be taken hostage by its intensity, fascinating developments, and the fierce, compassionate girl leading the charge.” —<i>Booklist </i>(starred review)</b><br/><br/><b>“Deliberate, impeccable, and extraordinary.” —<i>Kirkus Reviews</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Hardinge
      </h2>
      
      <p class="authorDescription body article">Frances Hardinge is the winner of the Costa Book of the Year for The Lie Tree, one of just two young adult novels to win the major UK literary prize. She is the author of several books for children, including Cuckoo Song, The Lost Conspiracy, Fly by Night, Well Witched, and Fly Trap. She lives in England. Visit the author at franceshardinge.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f0d3ec8